import { render } from "./WeatherStats.vue?vue&type=template&id=fcd35906&scoped=true"
import script from "./WeatherStats.vue?vue&type=script&lang=js"
export * from "./WeatherStats.vue?vue&type=script&lang=js"

import "./WeatherStats.vue?vue&type=style&index=0&id=fcd35906&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcd35906"]])

export default __exports__